import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { managers, trucks } from '../data/dummyData';

// 가짜 지도 컴포넌트 (Kakao/Naver API 없이 시각적으로 구현)
const MockMap = ({ selectedManager, onManagerClick }) => {
  const managerPositions = [
    { id: 1, top: '38%', left: '45%', color: '#27AE60' },
    { id: 2, top: '25%', left: '60%', color: '#27AE60' },
    { id: 3, top: '55%', left: '35%', color: '#F39C12' },
    { id: 4, top: '62%', left: '65%', color: '#27AE60' },
    { id: 5, top: '30%', left: '22%', color: '#27AE60' },
  ];
  const truckPositions = [
    { id: 1, top: '70%', left: '55%' },
    { id: 2, top: '45%', left: '75%' },
  ];

  return (
    <div style={{
      width: '100%', height: '100%', position: 'relative',
      background: 'linear-gradient(160deg, #e8f5e9 0%, #e3f2fd 50%, #f3e5f5 100%)',
      overflow: 'hidden'
    }}>
      {/* 도로 패턴 */}
      <svg width="100%" height="100%" style={{ position: 'absolute', top: 0, left: 0, opacity: 0.3 }}>
        <line x1="0" y1="50%" x2="100%" y2="50%" stroke="#bbb" strokeWidth="8"/>
        <line x1="50%" y1="0" x2="50%" y2="100%" stroke="#bbb" strokeWidth="6"/>
        <line x1="0" y1="25%" x2="100%" y2="35%" stroke="#bbb" strokeWidth="4"/>
        <line x1="15%" y1="0" x2="25%" y2="100%" stroke="#bbb" strokeWidth="4"/>
        <line x1="70%" y1="0" x2="80%" y2="100%" stroke="#bbb" strokeWidth="3"/>
        <circle cx="50%" cy="50%" r="60" fill="none" stroke="#ccc" strokeWidth="3"/>
        <rect x="30%" y="30%" width="15%" height="10%" rx="4" fill="#c8e6c9" opacity="0.6"/>
        <rect x="55%" y="20%" width="18%" height="12%" rx="4" fill="#bbdefb" opacity="0.6"/>
        <rect x="20%" y="60%" width="14%" height="8%" rx="4" fill="#e1bee7" opacity="0.6"/>
      </svg>

      {/* 내 위치 */}
      <div style={{
        position: 'absolute', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)', zIndex: 10
      }}>
        <div style={{
          width: 24, height: 24, background: '#2980B9', borderRadius: '50%',
          border: '3px solid white', boxShadow: '0 2px 8px rgba(41,128,185,0.6)'
        }}/>
        <div style={{
          position: 'absolute', width: 48, height: 48, borderRadius: '50%',
          background: 'rgba(41,128,185,0.15)', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)', animation: 'pulse 2s infinite'
        }}/>
      </div>

      {/* 영차매니저 핀 */}
      {managerPositions.map((pos) => {
        const mgr = managers.find(m => m.id === pos.id);
        const isSelected = selectedManager?.id === pos.id;
        return (
          <div
            key={pos.id}
            style={{
              position: 'absolute', top: pos.top, left: pos.left,
              transform: isSelected ? 'translate(-50%,-50%) scale(1.3)' : 'translate(-50%,-50%)',
              zIndex: isSelected ? 20 : 10,
              cursor: 'pointer', transition: 'transform 0.2s'
            }}
            onClick={() => onManagerClick(mgr)}
          >
            <div style={{
              background: pos.color, width: 36, height: 36, borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, border: isSelected ? '3px solid #FF6B35' : '2px solid white',
              boxShadow: '0 3px 10px rgba(0,0,0,0.2)'
            }}>
              {mgr?.emoji || '🚚'}
            </div>
            {isSelected && (
              <div style={{
                position: 'absolute', top: '-28px', left: '50%',
                transform: 'translateX(-50%)', background: '#FF6B35',
                color: 'white', padding: '2px 8px', borderRadius: '8px',
                fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap'
              }}>
                {mgr?.name}
              </div>
            )}
          </div>
        );
      })}

      {/* 공차(용달차) 핀 */}
      {truckPositions.map((pos, i) => (
        <div
          key={i}
          style={{
            position: 'absolute', top: pos.top, left: pos.left,
            transform: 'translate(-50%,-50%)',
          }}
        >
          <div style={{
            background: '#8E44AD', width: 32, height: 32, borderRadius: '8px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 14, border: '2px solid white', boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
          }}>
            🚚
          </div>
        </div>
      ))}

      {/* 범례 */}
      <div style={{
        position: 'absolute', bottom: 12, right: 12,
        background: 'rgba(255,255,255,0.92)', borderRadius: 8,
        padding: '8px 10px', fontSize: 11, display: 'flex', flexDirection: 'column', gap: 4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#2980B9' }}/>
          <span style={{ color: '#374151', fontWeight: 600 }}>내 위치</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#27AE60' }}/>
          <span style={{ color: '#374151', fontWeight: 600 }}>영차매니저</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: 10, height: 10, borderRadius: '6px', background: '#8E44AD' }}/>
          <span style={{ color: '#374151', fontWeight: 600 }}>공차 이동 중</span>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0% { transform: translate(-50%, -50%) scale(1); opacity: 0.6; }
          100% { transform: translate(-50%, -50%) scale(2); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

const MainPage = ({ user }) => {
  const navigate = useNavigate();
  const [selectedManager, setSelectedManager] = useState(null);
  const [searchLink, setSearchLink] = useState('');
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [showManagerModal, setShowManagerModal] = useState(false);
  const [activeTab, setActiveTab] = useState('managers'); // managers | trucks

  const handleManagerClick = (mgr) => {
    setSelectedManager(mgr);
    setShowManagerModal(true);
  };

  const handleLinkSubmit = () => {
    if (searchLink.trim()) {
      navigate('/ai-analysis', { state: { link: searchLink } });
    }
  };

  const onlineCount = managers.filter(m => m.status === 'online').length;
  const movingTrucks = trucks.filter(t => t.type !== 'idle').length;

  return (
    <div className="page" style={{ background: 'white' }}>
      {/* 헤더 */}
      <div style={{
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF8C5A 100%)',
        padding: '20px 20px 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* 배경 패턴 */}
        <div style={{
          position: 'absolute', top: -20, right: -20,
          width: 160, height: 160, borderRadius: '50%',
          background: 'rgba(255,255,255,0.08)'
        }}/>
        <div style={{
          position: 'absolute', top: 30, right: 60,
          width: 80, height: 80, borderRadius: '50%',
          background: 'rgba(255,255,255,0.06)'
        }}/>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
              <span style={{ fontSize: 24 }}>🚐</span>
              <span style={{ color: 'white', fontSize: 22, fontWeight: 800, letterSpacing: '-0.5px' }}>어디용차</span>
            </div>
            <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>
              가는 길에, 믿고 맡기세요
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button
              onClick={() => navigate('/profile')}
              style={{
                background: 'rgba(255,255,255,0.2)', border: 'none',
                borderRadius: '50%', width: 42, height: 42,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', color: 'white', fontSize: 18
              }}
            >
              👤
            </button>
          </div>
        </div>

        {/* 현황 배지 */}
        <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
          <div style={{
            background: 'rgba(255,255,255,0.2)', borderRadius: 12,
            padding: '8px 14px', backdropFilter: 'blur(10px)'
          }}>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 10, marginBottom: 2 }}>지금 가능한 매니저</div>
            <div style={{ color: 'white', fontWeight: 800, fontSize: 20 }}>
              {onlineCount}<span style={{ fontSize: 13 }}>명</span>
            </div>
          </div>
          <div style={{
            background: 'rgba(255,255,255,0.2)', borderRadius: 12,
            padding: '8px 14px', backdropFilter: 'blur(10px)'
          }}>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 10, marginBottom: 2 }}>이동 중인 공차</div>
            <div style={{ color: 'white', fontWeight: 800, fontSize: 20 }}>
              {movingTrucks}<span style={{ fontSize: 13 }}>대</span>
            </div>
          </div>
          <div style={{
            background: 'rgba(255,255,255,0.2)', borderRadius: 12,
            padding: '8px 14px', backdropFilter: 'blur(10px)'
          }}>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 10, marginBottom: 2 }}>오늘 완료 배송</div>
            <div style={{ color: 'white', fontWeight: 800, fontSize: 20 }}>
              43<span style={{ fontSize: 13 }}>건</span>
            </div>
          </div>
        </div>

        {/* 탭 */}
        <div style={{ display: 'flex', gap: 4 }}>
          {[
            { key: 'managers', label: '🧑 영차매니저' },
            { key: 'trucks', label: '🚚 공차현황' },
          ].map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                flex: 1, padding: '10px 0', border: 'none', cursor: 'pointer',
                background: activeTab === tab.key ? 'white' : 'transparent',
                color: activeTab === tab.key ? '#FF6B35' : 'rgba(255,255,255,0.8)',
                fontWeight: 700, fontSize: 14, borderRadius: '12px 12px 0 0',
                transition: 'all 0.2s'
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* 지도 영역 */}
      <div style={{ position: 'relative' }}>
        <div style={{ width: '100%', height: 260 }}>
          <MockMap selectedManager={selectedManager} onManagerClick={handleManagerClick} />
        </div>
        {/* 서비스 요청 플로팅 버튼 */}
        <button
          onClick={() => navigate('/service-select')}
          style={{
            position: 'absolute', bottom: 16, left: '50%',
            transform: 'translateX(-50%)',
            background: '#FF6B35', color: 'white', border: 'none',
            borderRadius: 50, padding: '12px 28px',
            fontWeight: 700, fontSize: 15, cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(255,107,53,0.5)',
            display: 'flex', alignItems: 'center', gap: 8,
            whiteSpace: 'nowrap'
          }}
        >
          <span>🚐</span> 지금 배송 요청하기
        </button>
      </div>

      {/* 링크로 가구 분석 */}
      <div style={{ padding: '16px 20px', background: '#FFF8F5', borderBottom: '1px solid #FFE0D0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: '#333', display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>🤖</span> AI 가구 분석
          </div>
          <button
            onClick={() => setShowLinkInput(!showLinkInput)}
            style={{
              background: '#FF6B35', color: 'white', border: 'none',
              borderRadius: 8, padding: '6px 14px', fontSize: 13,
              fontWeight: 600, cursor: 'pointer'
            }}
          >
            {showLinkInput ? '닫기' : '링크로 분석하기'}
          </button>
        </div>

        {showLinkInput && (
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>
              당근마켓, 중고나라, 번개장터 상품 링크를 붙여넣으세요
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                value={searchLink}
                onChange={e => setSearchLink(e.target.value)}
                placeholder="https://당근마켓.com/..."
                style={{
                  flex: 1, padding: '10px 14px', border: '2px solid #FFE0D0',
                  borderRadius: 10, fontSize: 14, outline: 'none',
                  fontFamily: 'Noto Sans KR, sans-serif'
                }}
              />
              <button
                onClick={handleLinkSubmit}
                style={{
                  background: '#FF6B35', color: 'white', border: 'none',
                  borderRadius: 10, padding: '10px 16px', fontWeight: 700,
                  cursor: 'pointer', fontSize: 13
                }}
              >
                분석
              </button>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              {['당근마켓', '중고나라', '번개장터'].map(site => (
                <button
                  key={site}
                  style={{
                    flex: 1, padding: '8px 0', background: 'white',
                    border: '1px solid #FFE0D0', borderRadius: 8, fontSize: 12,
                    fontWeight: 600, cursor: 'pointer', color: '#FF6B35'
                  }}
                  onClick={() => {
                    setSearchLink(`https://${site}.com/sample-product`);
                  }}
                >
                  {site}
                </button>
              ))}
            </div>
          </div>
        )}

        {!showLinkInput && (
          <div style={{ fontSize: 12, color: '#999' }}>
            중고 가구 링크를 붙여넣으면 AI가 무게·크기·요금을 자동 분석합니다
          </div>
        )}
      </div>

      {/* 매니저 목록 / 공차 목록 탭 내용 */}
      <div style={{ padding: '16px 20px' }}>
        {activeTab === 'managers' ? (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#1F2937' }}>
                📍 내 주변 영차매니저
              </div>
              <span style={{ fontSize: 12, color: '#6B7280', fontWeight: 600 }}>
                {onlineCount}명 지금 가능
              </span>
            </div>

            <div className="scroll-x">
              {managers.map(mgr => (
                <div
                  key={mgr.id}
                  className="manager-card"
                  style={{ borderColor: selectedManager?.id === mgr.id ? '#FF6B35' : 'transparent' }}
                  onClick={() => handleManagerClick(mgr)}
                >
                  <div style={{ position: 'relative', marginBottom: 8 }}>
                    <div className="manager-avatar">{mgr.emoji}</div>
                    <div style={{
                      position: 'absolute', top: 0, right: 0,
                      width: 12, height: 12, borderRadius: '50%',
                      background: mgr.status === 'online' ? '#27AE60' : '#F39C12',
                      border: '2px solid white'
                    }}/>
                    {mgr.verificationBadge && (
                      <div style={{
                        position: 'absolute', bottom: 0, left: 30,
                        background: '#FF6B35', borderRadius: 4, padding: '1px 4px',
                        fontSize: 8, color: 'white', fontWeight: 700
                      }}>인증</div>
                    )}
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1F2937' }}>{mgr.name}</div>
                  <div style={{ fontSize: 12, color: '#9CA3AF', marginBottom: 4 }}>{mgr.area}</div>
                  <div style={{ fontSize: 12, color: '#F39C12', marginBottom: 4 }}>
                    ⭐ {mgr.rating} ({mgr.reviews})
                  </div>
                  <div style={{
                    fontSize: 11, color: mgr.status === 'online' ? '#27AE60' : '#F39C12',
                    fontWeight: 600, marginBottom: 4
                  }}>
                    {mgr.status === 'online' ? '🟢' : '🟡'} {mgr.statusLabel}
                  </div>
                  <div style={{ fontSize: 12, color: '#6B7280' }}>📍 {mgr.distance}km</div>
                  <div style={{ fontSize: 13, color: '#FF6B35', fontWeight: 700, marginTop: 4 }}>
                    기본 {mgr.price.toLocaleString()}원~
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#1F2937' }}>
                🚚 이동 중인 공차
              </div>
              <span style={{ fontSize: 12, color: '#8E44AD', fontWeight: 600 }}>
                공차 이용 시 최대 50% 절약
              </span>
            </div>
            {trucks.map(truck => (
              <div
                key={truck.id}
                className="truck-card"
                onClick={() => navigate('/truck-match', { state: { selectedTruck: truck } })}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                    <div style={{
                      width: 48, height: 48, borderRadius: 12,
                      background: truck.type === 'longDistance' ? '#f3e5f5' : truck.type === 'returning' ? '#e8f5e9' : '#e8f4fd',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22
                    }}>
                      {truck.emoji}
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14, color: '#1F2937' }}>{truck.vehicle}</div>
                      <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>{truck.from}</div>
                      <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 1 }}>도착: {truck.eta}</div>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{
                      background: '#f3e5f5', color: '#8E44AD',
                      padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                      marginBottom: 4, whiteSpace: 'nowrap'
                    }}>
                      {truck.discountRate}% 절약
                    </div>
                    <div style={{ fontSize: 12, color: '#F39C12' }}>⭐ {truck.rating}</div>
                  </div>
                </div>
                <div style={{
                  marginTop: 10, padding: '8px 12px',
                  background: '#f9fafb', borderRadius: 8,
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                }}>
                  <span style={{ fontSize: 12, color: '#4B5563' }}>{truck.loadText}</span>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <div style={{
                      width: 80, height: 6, background: '#E5E7EB', borderRadius: 3, overflow: 'hidden'
                    }}>
                      <div style={{
                        width: truck.loadCapacity, height: '100%',
                        background: '#8E44AD', borderRadius: 3
                      }}/>
                    </div>
                    <span style={{ fontSize: 11, color: '#8E44AD', fontWeight: 600 }}>{truck.loadCapacity}</span>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      {/* 서비스 소개 카드 */}
      <div style={{ padding: '0 20px 20px' }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: '#1F2937', marginBottom: 12 }}>
          🎯 어디용차 서비스
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {[
            { icon: '🔍', title: '검증 서비스', desc: '구매 전 현장 확인\n하자 발견 시 검증비만', color: '#e8f5e9', btnColor: '#27AE60', path: '/service-select', tab: 'verify' },
            { icon: '🚚', title: '용달 배송', desc: '투명 요금제\n합리적인 배송비', color: '#e8f4fd', btnColor: '#2980B9', path: '/service-select', tab: 'delivery' },
            { icon: '🛣️', title: '공차 매칭', desc: '이사 귀환 차량\n최대 50% 절약', color: '#f3e5f5', btnColor: '#8E44AD', path: '/truck-match', tab: '' },
            { icon: '🧑‍💼', title: '매니저 등록', desc: '수익 창출\n내 지역 배송 전담', color: '#fff3cd', btnColor: '#F39C12', path: '/manager-register', tab: '' },
          ].map((svc, i) => (
            <button
              key={i}
              onClick={() => navigate(svc.path, { state: { tab: svc.tab } })}
              style={{
                background: svc.color, border: 'none', borderRadius: 16,
                padding: '16px 14px', cursor: 'pointer', textAlign: 'left',
                transition: 'transform 0.2s',
              }}
              onTouchStart={e => e.currentTarget.style.transform = 'scale(0.97)'}
              onTouchEnd={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              <div style={{ fontSize: 28, marginBottom: 8 }}>{svc.icon}</div>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1F2937', marginBottom: 4 }}>{svc.title}</div>
              <div style={{ fontSize: 11, color: '#6B7280', lineHeight: 1.5, whiteSpace: 'pre-line' }}>{svc.desc}</div>
            </button>
          ))}
        </div>
      </div>

      {/* 투명 요금제 안내 */}
      <div style={{ margin: '0 20px 20px', background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)', borderRadius: 16, padding: 20 }}>
        <div style={{ color: 'white', fontWeight: 800, fontSize: 16, marginBottom: 8 }}>
          💰 투명 요금제
        </div>
        <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13, lineHeight: 1.7 }}>
          기본요금 <span style={{ color: '#FF6B35', fontWeight: 700 }}>10,000원</span> + 거리 당 <span style={{ color: '#FF6B35', fontWeight: 700 }}>2,000원/km</span><br/>
          엘리베이터 있음 5,000원 • 계단 층당 3,000원<br/>
          무거운 짐(50kg↑) 5,000원 추가
        </div>
        <button
          onClick={() => navigate('/pricing')}
          style={{
            marginTop: 12, background: '#FF6B35', color: 'white', border: 'none',
            borderRadius: 10, padding: '10px 20px', fontWeight: 700, cursor: 'pointer', fontSize: 13
          }}
        >
          요금 계산하기 →
        </button>
      </div>

      {/* 최근 리뷰 */}
      <div style={{ padding: '0 20px 80px' }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: '#1F2937', marginBottom: 12 }}>
          ⭐ 최근 이용 후기
        </div>
        {[
          { user: '당근마켓 구매자', rating: 5, text: '소파 운반 꼼꼼히 해주셨어요! 사진도 보내주셔서 안심했어요 👍', time: '2시간 전' },
          { user: '중고나라 이용자', rating: 5, text: '냉장고 검증 서비스 최고! 하자 없는 거 확인하고 구매했어요.', time: '5시간 전' },
          { user: '번개장터 구매자', rating: 4, text: '공차 서비스로 50% 할인! 부산에서 서울까지 저렴하게 가져왔어요.', time: '1일 전' },
        ].map((r, i) => (
          <div key={i} style={{
            background: 'white', borderRadius: 12, padding: 16,
            marginBottom: 10, border: '1px solid #F3F4F6',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <span style={{ fontWeight: 700, fontSize: 14, color: '#1F2937' }}>{r.user}</span>
              <span style={{ fontSize: 12, color: '#9CA3AF' }}>{r.time}</span>
            </div>
            <div style={{ color: '#F39C12', fontSize: 13, marginBottom: 6 }}>
              {'⭐'.repeat(r.rating)}
            </div>
            <div style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.6 }}>{r.text}</div>
          </div>
        ))}
      </div>

      {/* 매니저 상세 모달 */}
      {showManagerModal && selectedManager && (
        <div className="modal-overlay" onClick={() => setShowManagerModal(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle"/>
            <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
              <div style={{
                width: 64, height: 64, borderRadius: '50%', background: '#FFF0EB',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30
              }}>
                {selectedManager.emoji}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontWeight: 800, fontSize: 18 }}>{selectedManager.name}</span>
                  {selectedManager.verificationBadge && (
                    <span style={{ background: '#FF6B35', color: 'white', padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 700 }}>인증</span>
                  )}
                </div>
                <div style={{ color: '#F39C12', fontSize: 14, marginTop: 2 }}>
                  ⭐ {selectedManager.rating} ({selectedManager.reviews}건)
                </div>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4,
                  padding: '3px 10px', borderRadius: 20,
                  background: selectedManager.status === 'online' ? '#e8f8ef' : '#fef9e7',
                  color: selectedManager.status === 'online' ? '#27AE60' : '#F39C12',
                  fontSize: 12, fontWeight: 600
                }}>
                  <span>{selectedManager.status === 'online' ? '🟢' : '🟡'}</span>
                  {selectedManager.statusLabel}
                </div>
              </div>
            </div>

            {[
              { label: '담당 지역', val: selectedManager.area },
              { label: '보유 차량', val: selectedManager.vehicle },
              { label: '내 위치에서', val: `${selectedManager.distance}km` },
              { label: '완료 배송', val: `${selectedManager.completedJobs}건` },
              { label: '기본 요금', val: `${selectedManager.price.toLocaleString()}원~` },
            ].map((item, i) => (
              <div key={i} className="info-row">
                <span className="info-key">{item.label}</span>
                <span className="info-val">{item.val}</span>
              </div>
            ))}

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 12, marginBottom: 16 }}>
              {selectedManager.tags.map((tag, i) => (
                <span key={i} className="tag" style={{ background: '#FFF0EB', color: '#FF6B35' }}>#{tag}</span>
              ))}
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button
                className="btn btn-outline"
                style={{ flex: 1 }}
                onClick={() => { setShowManagerModal(false); navigate('/pricing', { state: { managerId: selectedManager.id } }); }}
              >
                요금 확인
              </button>
              <button
                className="btn btn-primary"
                style={{ flex: 1 }}
                onClick={() => { setShowManagerModal(false); navigate('/booking', { state: { manager: selectedManager } }); }}
              >
                바로 요청
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainPage;
